import { IconProps } from '../../Icon.types';

export const Personal3DIcon = ({ width, height, color }: IconProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_i_3982_59696)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M24.0008 18C22.0126 18 20.4008 19.6118 20.4008 21.6C20.4008 23.5883 22.0126 25.2001 24.0008 25.2001C25.989 25.2001 27.6008 23.5883 27.6008 21.6C27.6008 19.6118 25.989 18 24.0008 18ZM16.8008 21.6C16.8008 17.6236 20.0243 14.4 24.0008 14.4C27.9772 14.4 31.2008 17.6236 31.2008 21.6C31.2008 25.5765 27.9772 28.8 24.0008 28.8C20.0243 28.8 16.8008 25.5765 16.8008 21.6Z"
          fill={color}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M17.1074 4.80005C13.2428 4.80005 11.4911 5.13077 9.71192 6.08229C8.15212 6.91648 6.91721 8.15138 6.08302 9.71119C5.1315 11.4904 4.80078 13.242 4.80078 17.1067V30.8934C4.80078 34.7581 5.1315 36.5097 6.08302 38.2889C6.91721 39.8487 8.15212 41.0836 9.71192 41.9178C11.4911 42.8693 13.2428 43.2001 17.1074 43.2001H30.8941C34.7588 43.2001 36.5105 42.8693 38.2896 41.9178C39.8494 41.0836 41.0844 39.8487 41.9185 38.2889C42.8701 36.5097 43.2008 34.7581 43.2008 30.8934V17.1067C43.2008 13.242 42.8701 11.4904 41.9185 9.71119C41.0844 8.15139 39.8494 6.91648 38.2896 6.08229C36.5105 5.13077 34.7588 4.80005 30.8941 4.80005H17.1074ZM30.8941 39.6001C32.7646 39.6001 33.9506 39.5153 34.7948 39.3622C32.0644 36.5469 28.2425 34.8 24.0121 34.8C19.7799 34.8 15.9566 36.5483 13.2259 39.3657C14.069 39.5166 15.2511 39.6001 17.1074 39.6001H30.8941ZM11.4097 9.25681C12.4002 8.72705 13.433 8.40005 17.1074 8.40005H30.8941C34.5685 8.40005 35.6013 8.72705 36.5919 9.25681C37.5243 9.75549 38.2453 10.4765 38.744 11.4089C39.2738 12.3995 39.6008 13.4323 39.6008 17.1067V30.8934C39.6008 34.5678 39.2738 35.6006 38.744 36.5912C38.5483 36.9572 38.3182 37.2907 38.0546 37.5909C34.644 33.6773 29.6175 31.2 24.0121 31.2C18.4005 31.2 13.3691 33.6827 9.95831 37.6037C9.68993 37.3002 9.45611 36.9624 9.25755 36.5912C8.72778 35.6006 8.40078 34.5678 8.40078 30.8934V17.1067C8.40078 13.4323 8.72778 12.3995 9.25755 11.4089C9.75622 10.4765 10.4772 9.75549 11.4097 9.25681ZM16.8008 21.6C16.8008 17.6236 20.0243 14.4 24.0008 14.4C27.9772 14.4 31.2008 17.6236 31.2008 21.6C31.2008 25.5765 27.9772 28.8 24.0008 28.8C20.0243 28.8 16.8008 25.5765 16.8008 21.6ZM24.0008 18C22.0126 18 20.4008 19.6118 20.4008 21.6C20.4008 23.5883 22.0126 25.2001 24.0008 25.2001C25.989 25.2001 27.6008 23.5883 27.6008 21.6C27.6008 19.6118 25.989 18 24.0008 18Z"
          fill={color}
        />
      </g>
      <defs>
        <filter
          id="filter0_i_3982_59696"
          x="3.80078"
          y="4.80005"
          width="39.4004"
          height="39.3999"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="-1" dy="1" />
          <feGaussianBlur stdDeviation="0.5" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.2 0 0 0 0 0.2 0 0 0 0 0.211765 0 0 0 0.12 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect1_innerShadow_3982_59696"
          />
        </filter>
      </defs>
    </svg>
  );
};
